import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Minus } from 'lucide-react';
import { cx } from './cx.js';
/** The selected state per group name of the control around the mark - spelt out for Tailwind. */
const SELECTED = {
    box: 'group-data-selected/box:bg-accent group-data-selected/box:ring-accent',
    row: 'group-data-selected/row:bg-accent group-data-selected/row:ring-accent',
    plain: 'group-data-selected:bg-accent group-data-selected:ring-accent group-data-indeterminate:bg-accent group-data-indeterminate:ring-accent',
};
const TICK = {
    box: 'group-data-selected/box:block',
    row: 'group-data-selected/row:block',
    plain: 'group-data-selected:block',
};
/**
 * The mark of every checkbox: a round box, filled with the accent and ticked when chosen - one
 * look across lists, answers and cards. `group` names the control it sits in.
 */
export function CheckMark({ group, className, }) {
    return (_jsxs("span", { "aria-hidden": true, className: cx('grid size-5 shrink-0 place-items-center rounded-full ring-[1.5px] ring-muted ring-inset', SELECTED[group], className), children: [_jsx(Check, { className: cx('hidden size-3.5 text-accent-on', TICK[group]), strokeWidth: 3 }), group === 'plain' && (_jsx(Minus, { className: "hidden size-3.5 text-accent-on group-data-indeterminate:block", strokeWidth: 3 }))] }));
}
//# sourceMappingURL=check-mark.js.map